<template>
  <v-container fluid class="pa-0">
    <div v-if="!isContentLoaded" transition="content-load-transition">
      <p class="text-xs-center font-weight-bold">
        {{ $t("events.loading") }}...
      </p>
    </div>
    <v-row
      row
      wrap
      justify="space-between"
      v-else
      transition="content-load-transition"
    >
      <v-col pa-1 v-for="event in filteredEvents" :key="event.id" sm="6" md="4">
        <v-card class="event-card">
          <v-card-title class="pa-0">
            <v-img
              class="event-img"
              src="https://picsum.photos/3840/2150"
              aspect-ratio="2"
            ></v-img>
          </v-card-title>
          <v-card-text class="px-0 py-2">
            <v-row no-gutters justify="space-between" align="center">
              <h3 class="title font-weight-bold">{{ event.title }}</h3>
              <div class="event-date">
                {{ event.date | date("DD/MM/YYYY", $i18n.locale) }}
              </div>
            </v-row>
            <p class="event-desc">{{ event.desc }}</p>
          </v-card-text>
          <v-card-actions class="pa-0">
            <v-btn class="ma-0" text color="primary">{{
              $t("events.goToLink")
            }}</v-btn>
          </v-card-actions>
        </v-card>
      </v-col>
    </v-row>
    <v-row no-gutters justify="start">
      <v-btn rounded depressed color="primary" class="my-4">
        {{ $t("events.goToEvents") }}
      </v-btn>
    </v-row>
  </v-container>
</template>

<script>
export default {
  data() {
    return {
      drawer: true,
      isContentLoaded: false,
      events: []
    };
  },
  computed: {
    filteredEvents() {
      // filter top-3 events according to specific attributes
      return this.$store.getters["fondoEstPerTe/getTopNEvents"](3);
    }
  },
  methods: {},
  created() {
    this.$store.dispatch("fondoEstPerTe/fetchEvents").then(events => {
      this.events = events;
      this.isContentLoaded = true;
    });
    // this.events = this.$store.getters["fondoEstPerTe/events"];
  }
};
</script>

<style scoped>
.container {
  padding: 0;
}

.v-btn {
  margin: 0;
}

.more-events-trigger-container {
  padding: 15px;
  text-align: center;
}

.row.column {
  align-items: start;
}

.event-card {
  box-shadow: unset;
  border-radius: 10px;
  border: 3px solid var(--primary);
  padding: 10px;
  margin-bottom: 5px;
}

.event-img {
  border-radius: 5px;
  height: 135px;
}

.event-date {
  font-size: 14px;
  border-radius: 6px;
  color: var(--primary);
  font-weight: 500;
}

.v-btn {
  font-size: 12px;
  font-weight: bold;
}

.event-desc {
  font-size: 12px;
  font-weight: 500;
  margin-top: 10px;
}

.content-load-transition {
  transition: all 0.25s ease;
}
</style>
